import * as React from 'react'
import { SVGProps } from 'react'

const SvgAddPacakgeIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
		<path
			fill="currentColor"
			d="M13 15.6c.3.2.7.2 1 0l5-2.9v.3c.7 0 1.4.1 2 .4v-1.8l1-.6c.5-.3.6-.9.4-1.4l-1.5-2.5c-.1-.2-.2-.4-.4-.5l-7.9-4.4c-.2-.1-.4-.2-.6-.2s-.4.1-.6.2L3.6 6.6c-.2.1-.4.2-.5.4L1.6 9.6c-.3.5-.1 1.1.4 1.4.3.2.7.2 1 0v5.5c0 .4.2.7.5.9l7.9 4.4c.2.1.4.2.6.2s.4-.1.6-.2l.9-.5c-.3-.6-.4-1.3-.5-2m-2 0-6-3.4V9.2l6 3.4v6.7m9.1-9.6-6.3 3.6-.6-1 6.3-3.6.6 1M12 10.8V4.2l6 3.3-6 3.3m8 4.2v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z"
		/>
	</svg>
)
export default SvgAddPacakgeIcon
